import {
  AddOnFilterModel,
  FeatureName,
  useAddOnFilter,
  useCurrentWorkspace,
  useIsFeatureEnabled,
} from '@gripp/shared-logic';
import { SlideLayout } from '@gripp/shared-ui';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { AddOns as AddOnsBaseOld } from './addOns-old';
import { AddOnsFilters } from './addOnsFilters';
import { AddOnsList } from './addOnsList';

export const AddOns = () => {
  const isCropCircleEnable = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  if (isCropCircleEnable) {
    return <AddOnsBase />;
  }

  return <AddOnsBaseOld />;
};

export const AddOnsBase = ({
  rightColumn,
  viewMode,
}: {
  rightColumn?: any;
  viewMode?: any;
}) => {
  const { data: addOnFilter } = useAddOnFilter();

  const impersonatingWorkspace = useCurrentWorkspace(true);
  const currentWorkspace = useCurrentWorkspace();

  const showCheckboxColumn = useMemo(
    () => !!impersonatingWorkspace,
    [impersonatingWorkspace]
  );

  const filter = useMemo(() => {
    const filter: AddOnFilterModel = addOnFilter ?? new AddOnFilterModel();
    filter.workspaceId = currentWorkspace?.id;
    return filter.getGraphQLFilter();
  }, [addOnFilter, currentWorkspace?.id]);

  const filterComponent = <AddOnsFilters />;

  const columnComponent = (
    <View style={styles.container}>
      <AddOnsList filter={filter} showCheckboxColumn={showCheckboxColumn} />
    </View>
  );

  return (
    <SlideLayout
      leftColumn={{
        title: 'addOn.list.addOns',
        mainComponent: columnComponent,
        headerComponent: filterComponent,
      }}
      rightColumn={rightColumn}
      viewMode={viewMode}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
  },
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  searchContainer: {
    width: 390,
    marginRight: 20,
  },
});
